import { render, staticRenderFns } from "./RecursiveRows.vue?vue&type=template&id=4b961d19&"
import script from "./RecursiveRows.vue?vue&type=script&lang=js&"
export * from "./RecursiveRows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports